var notifyMeComponent = function($) {

    var $form,
        $inputs,
        noError;

    function validateGeneralRules(input) {
        var regex1 = /(https)|(http)|(www)/ig;
        var regex2 = /[\~$%^*\[\]}{><=|]/g;

        if (regex1.test(input.value)) {
            throwError(input, 'data-error-www');
            return false;
        }
        if (regex2.test(input.value)) {
            throwError(input, 'data-error-specialChars');
            return false;
        }
        return true;
    }

    function validateRequired(input) {
        if (input.value.trim() === "") {
            throwError(input, 'data-error-required');
            return false;
        }
        return true;
    }

    function validateEmail(input) {
        var regex = /^([\w-]+(?:\.[\w-]+)*)@((?:[\w-]+\.)*\w[\w-]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$/i;
        var emailTest = regex.test(input.value);

        return !emailTest && throwError(input, 'data-error-valid');

    }

    function hideError($input) {
        $input.parent().removeClass("has-error");
        $input.parent().find(".contact-form__error").remove();
    }

    function throwError(input, dataError) {
        var $inputElem = $("[name=" + input.name + "]"),
            message,
            errorMessage;

        noError = false;
        message = dataError ? $inputElem.attr(dataError) : "";
        errorMessage = "<p class='contact-form__error'>" + message + "</p>";

        if ($inputElem.parent().hasClass("has-error")) {
            $inputElem.parent().find(".contact-form__error").text(message);
        } else {
            $inputElem.parent().addClass("has-error").append(errorMessage);
        }
    }

    function validateForm() {
        var inputsArr = $form.serializeArray();
        noError = true;
        $(inputsArr).each(function(i, v) {
            switch (v.name) {
                case "cons_first_name":
                    validateGeneralRules(v) && validateRequired(v);
                    break;

                case "cons_last_name":
                    validateGeneralRules(v) && validateRequired(v);
                    break;

                case "cons_email":
                    validateGeneralRules(v) && validateRequired(v) && validateEmail(v);
                    break;
            }
        });

        if (noError) {
            return true;
        }
        return false;
    }

    function bindEvents() {

        $form.find(":input").on("focus", function() {
            var $this = $(this);
            if ($this.parent().hasClass("has-error")) {
                noError = false;
                hideError($this);
            }
        });

        $submitBtn.on("click", function(e) {
            var isFormValid = validateForm();
            if(isFormValid)
                return true;
            else {
                return false;
            }
        });
    }

    function init() {

        $form = $("#crisis-hero__form");

        if($form.length > 0){
            $submitBtn = $('.js-formSubmit');
            bindEvents();
        }
    }

    return {
        init: init
    };
}(jQuery);

$(function() {
    notifyMeComponent.init();
});
